import { reactive, watch } from 'vue'
import { onHotReload } from '../debug/onHotreload';

export type UseEffect = {
  pause: () => void;
  resume: () => void;
  stop: () => void;
}

export type UseEffectContext = {
  pause: () => void;
  resume: () => void;
}

export type UseEffectFunction = (ctx: UseEffectContext) => void | Promise<void>



export const useEffect = (fun: UseEffectFunction, deps: any[], deep: boolean = false, once: boolean = false, immediate: boolean = true): UseEffect => {
  const state = reactive<{
    paused: boolean
  }>({
    paused: false
  });

  const pause = () => {
    state.paused = true;
  }

  const resume = () => {
    state.paused = false;
  }

  const stop = watch(
    deps,
    () => {
      if (state.paused) return;
      try {
        fun({ pause, resume });

        if (once) {
          queueMicrotask(() => stop())
        }
      } catch (e) {
        console.error(e);
      }
    },
    { immediate: immediate, deep: deep }
  );

  onHotReload(() => {
    resume();
  })

  
  //onBeforeUnmount(stop)
  //onBeforeRouteLeave(stop)

  return { stop, pause, resume }
}
